import { render } from "./HistoriasPrevia.vue?vue&type=template&id=5ab4eb28"
import script from "./HistoriasPrevia.vue?vue&type=script&lang=js"
export * from "./HistoriasPrevia.vue?vue&type=script&lang=js"

import "./HistoriasPrevia.vue?vue&type=style&index=0&id=5ab4eb28&lang=css"
script.render = render

export default script